import { EditOutlined } from '@ant-design/icons';
import { Button, Space, Table, Typography } from 'antd';
import * as Component from 'components';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { roleService } from '../service/roleService';
import { PermissionType, RolePermissionType } from '../type/roleType';

export default function Role(): React.JSX.Element {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [refreshCounter, setRefreshCounter] = useState(0);

  const fetchRoles = useCallback(
    async (params: URLSearchParams): Promise<{ data: RolePermissionType[]; count: number }> => {
      const response = await roleService.fetch(params);
      return { data: response.results, count: response.count };
    },
    [searchParams]
  );

  const RolePermissionTable = ({ permissions }: { permissions: PermissionType[] }): JSX.Element => {
    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Code',
        dataIndex: 'code',
        key: 'code',
      },
    ];

    return (
      <div style={{ padding: '16px' }}>
        <Typography.Title level={4}>Permission List</Typography.Title>
        <Table
          columns={columns}
          dataSource={permissions}
          rowKey="id"
          bordered
          pagination={{ pageSize: 10 }}
        />
      </div>
    );
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_text: string, record: RolePermissionType): JSX.Element => (
        <Space>
          <Button
            icon={<EditOutlined />}
            type="primary"
            className="action-btn edit-btn"
            onClick={() => navigate(`/role/edit/${record.id}`)}
          />
        </Space>
      ),
    },
  ];

  const AddButton = (): JSX.Element => {
    return (
      <Component.CustomButtonComponent
        text={`+ Add Role`}
        onClick={() => navigate('/role/add')}
        size={'small'}
      />
    );
  };

  useEffect(() => {
    setRefreshCounter(prev => prev + 1);
  }, [searchParams]);

  return (
    <Component.BasePageComponent>
      <Component.TableComponent<RolePermissionType>
        key={refreshCounter}
        name="Role"
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        dataFetch={fetchRoles}
        columns={columns}
        additionalButton={[AddButton()]}
        actions={{
          onRowExpand: (record: RolePermissionType) => RolePermissionTable(record),
        }}
      />
    </Component.BasePageComponent>
  );
}
